const gtmId = process.env.NEXT_PUBLIC_GTM_ID
const gtmAuth = process.env.NEXT_PUBLIC_GTM_AUTH
const gtmPreview = process.env.NEXT_PUBLIC_GTM_PREVIEW

const gtmEnv =
  gtmAuth && gtmPreview
    ? `gtm_auth=${gtmAuth}&gtm_preview=${gtmPreview}&gtm_cookies_win=x`
    : null

type WindowWithDataLayer = Window & {
  dataLayer: Array<Record<string, unknown>>;
}

declare const window: WindowWithDataLayer

const pushToDataLayer = (data: Record<string, unknown>): void => {
  if (!window) {
    return
  }

  window.dataLayer = window.dataLayer || []

  window.dataLayer.push(data)
}

export {
  gtmId,
  gtmAuth,
  gtmPreview,
  gtmEnv,
  pushToDataLayer
}
